import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

function ScrollToFieldError(): JSX.Element {
  const { submitCount, errors, validateForm } = useFormikContext();

  useEffect(() => {
    validateForm().then(() => {
      if (!errors) return;

      const fieldErrorNames = Object.keys(errors);
      const element = document.querySelector(
        `input[name='${fieldErrorNames[0]}']`
      );

      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }, [submitCount]);

  return <></>;
}

export default ScrollToFieldError;
